'use strict';

const encoders = exports;

encoders.der = require('./der');
encoders.pem = require('./pem');



//////////////////
// WEBPACK FOOTER
// ./~/asn1.js/lib/asn1/encoders/index.js
// module id = 66
// module chunks = 0